import './home.scss'

import { AuthService } from '@skinsoft/auth';
import { User } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue';
import Component from 'vue-class-component';
import { appsConfig } from '../../../../config/apps.config';
import { router, Routes } from '../../../router';

declare const APPS_TO_DEPLOY: string[];

@Component({
    components: {

    },
    props: [''],
    template: require('./home.html')
})
export class Home extends ReactiveVue {
    private $authService: AuthService;
    private appLauncherIconsData: any[] = [];

    public created() {
        for (const appConfigName of APPS_TO_DEPLOY) {
            const appConfig = appsConfig[appConfigName]

            const titleKey = appConfig.nameI18NKey
            const title: string = this.$t(titleKey, this.$i18n.locale) as string
            this.appLauncherIconsData.push(
                {
                    appId: appConfig.id,
                    defaultRouteName: appConfig.defaultRouteName,
                    title,
                }
            )
        }
    }

    public mounted() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    }

    private emitApplicationChangeEvent(applicationName: string, defaultRoute: string) {
        setTimeout(() => this.$parent.$emit("application-change-topic", applicationName, defaultRoute), 300)
    }

    private onUser(user: User | null) {
        if (user) {
            return;
        }

        if (router.currentRoute.name !== Routes.LOGIN) {
            router.push({ name: Routes.LOGIN });
        }
    }

}